/**
 * @file   数据统计模块
 * @create tianmu 2021/3/3
 * @update tianmu 2021/3/3
 */
import React from 'react';
import { Layout } from 'antd';
import TODO from '../../assets/todo.png'

// 数据统计页面组件
export const Statistic = () => {

    return (
        <Layout className="statistic">
            <img
                style={{
                    // width: 550,
                    height: 400,
                    margin: '100px auto'
                }}
                src={TODO}
                alt=""
            />
        </Layout>
    );
};
